import {
  useState,
  useEffect,
  useReducer,
  Fragment,
  useRef,
  useContext,
} from "react";
import { axiosPut } from "@/services/axiosService";
import { useDispatch } from "react-redux";
import useStore from "@/pages/omni-builder/store";
import { userSlice } from "@/redux/User";
import * as MetaService from "@/services/facebook.service";
import BooleanModal from "../builder/BooleanModal";
import useWhatsAppConfig from "@/pages/omni-builder/react-query/configs/useWhatsAppConfig";
import { useQueryClient } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import ModalWrapper from "@/pages/cbb-builder/components/ModalWrapper";
import {
  ConnectIcon,
  DisconnectIcon,
} from "@/pages/cbb-builder/components/Channels/components/WhatsappChannel";
import { AnimatePresence, motion } from "framer-motion";
import { ErrSvgIcon } from "./Instagram";
import { BotContext } from "@/pages/cbb-builder/store";

interface Props {
  onClose?: any;
  botCustomId?: any;
  liveBotId?: any;
  setOpenPopUp?: any;
  // fromBuilder?: any;
  // getHandoffConfigs?: any;
  onSelect?: any;
}

export default function WhatsappNew({
  onClose,
  botCustomId,
  liveBotId,
  setOpenPopUp,
}: Props) {
  const dispatch = useDispatch();
  const [store, storeDispatch] = useContext(BotContext);
  const [state, setState] = useState(0);
  const [phoneNumbers, setPhoneNumbers] = useState<any[]>([]);
  const [whatsappDisconnecting, setWhatsappDisconnecting] =
    useState<boolean>(false);
  const setIsWhatsappLoading = useStore((state) => state.setIsWhatsappLoading);
  const queryClient = useQueryClient();
  const whatsappConfiguration = useWhatsAppConfig();
  const [fbReponse, setFbReponse] = useState<any>(null);
  const [connection, setConnection] = useState<any>(false);
  const [connectionStatus, setConnectionStatus] = useState({});
  const [isExist, setIsExist] = useState<any>({});
  const [searchParams] = useSearchParams();
  const [reload, fReload] = useReducer((state) => !state, false);
  const manualRef = useRef(false);

  useEffect(() => {
    if (whatsappConfiguration.isFetching) {
      setFbReponse(null);
      return;
    }

    if (whatsappConfiguration.isLoading || fbReponse) return;

    if (whatsappConfiguration.isError) {
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "error",
          message: "Error while fetching whatsapp configuration",
        }),
      );
      return;
    }

    const config = whatsappConfiguration.data;

    // ✅ CASE: config is null AFTER manual connect
    if (!config) {
      if (manualRef.current) {
        // User clicked "Connect WhatsApp" but config is still null after window closes
        dispatch(
          userSlice.actions.setToastPopUp({
            show: true,
            toastType: "error",
            message:
              "Failed to fetch WhatsApp configuration after connect. Please try again.",
          }),
        );
        manualRef.current = false; // reset to avoid repeated toast
      } else {
        // Normal load – no config – initiate connection flow
        const connectMeta = async () => {
          try {
            const forcedLogin = searchParams.get("forced") === "true";
            const loginLink = await MetaService.whatsappLogin(forcedLogin);
            const authWindow = window.open(
              loginLink,
              "_blank",
              "width=600,height=600",
            );

            const checkClosed = setInterval(async () => {
              if (authWindow?.self?.closed || authWindow?.closed) {
                storeDispatch({
                  type: "set-isChannel",
                  isChannel: true,
                });
                manualRef.current = true;
                queryClient.invalidateQueries({
                  queryKey: ["configurations", "whatsapp"],
                });
                clearInterval(checkClosed);
                setOpenPopUp(false);
              }
            }, 1000);
          } catch (error: any) {
            if (error.cause === "suppress") return;
            dispatch(
              userSlice.actions.setToastPopUp({
                show: true,
                toastType: "error",
                message: error?.message || "Something went wrong",
              }),
            );
          }
        };

        if (!manualRef.current) connectMeta();
      }

      return;
    }

    // ✅ Success case
    setPhoneNumbers(config?.phoneNumbers ?? []);
    setState(1);
  }, [whatsappConfiguration, fbReponse]);

  // useEffect(() => {
  //   if (whatsappConfiguration.isFetching) {
  //     setFbReponse(null);
  //     return;
  //   }
  //   if (whatsappConfiguration.isLoading || fbReponse) return;
  //   if (whatsappConfiguration.isError) {
  //     dispatch(
  //       userSlice.actions.setToastPopUp({
  //         show: true,
  //         toastType: "error",
  //         // message: whatsappConfiguration.error.message,
  //         message: "Error while fetching whatsapp configuration",
  //       }),
  //     );
  //     // onClose();
  //     return;
  //   }

  //   let config = whatsappConfiguration.data;
  //   if (!config) {
  //     const connectMeta = async () => {
  //       try {
  //         const forcedLogin = searchParams.get("forced");
  //         const forced = forcedLogin === "true" ? true : false;
  //         const loginLink = await MetaService.whatsappLogin(forced);
  //         const authWindow = window.open(
  //           loginLink,
  //           "_blank",
  //           "width=600,height=600",
  //         );
  //         const checkClosed = setInterval(async () => {
  //           if (authWindow?.self?.closed) {
  //             console.log("closed", authWindow);
  //             storeDispatch({
  //               type: "set-isChannel",
  //               isChannel: true,
  //             });
  //             manualRef.current = true;
  //             queryClient.invalidateQueries({
  //               queryKey: ["configurations", "whatsapp"],
  //             });
  //             clearInterval(checkClosed);
  //           } else if (authWindow?.closed) {
  //             console.log("self closed");
  //             setOpenPopUp(false);
  //             authWindow?.close();
  //             clearInterval(checkClosed);
  //             // onClose();
  //           }
  //         }, 1000);
  //       } catch (error: any) {
  //         if (error.cause === "suppress") return;
  //         const errMsg = typeof error === "string" ? error : error.message;

  //         dispatch(
  //           userSlice.actions.setToastPopUp({
  //             show: true,
  //             toastType: "error",
  //             message: errMsg || "Something went wrong",
  //           }),
  //         );
  //         // onClose();
  //       }
  //     };
  //     if (!manualRef.current) connectMeta();
  //     return;
  //   }

  //   setPhoneNumbers(config?.phoneNumbers ?? []);
  //   setState(1);
  // }, [whatsappConfiguration, fbReponse]);

  const disconnectMeta = async () => {
    try {
      setWhatsappDisconnecting(false);
      await axiosPut("/configurations/deleteAppConfig?siteName=whatsapp");
      dispatch(
        userSlice.actions.setToastPopUp({
          show: true,
          toastType: "success",
          message: "Your Meta WhatsApp account disconnected successfully",
        }),
      );

      await MetaService.logout();
      setIsWhatsappLoading(false);
      queryClient.invalidateQueries({
        queryKey: ["configurations", "whatsapp"],
      });
      // onClose();
    } catch (err) {
      console.log("error while disconnecting Account");
    }
  };

  const handleLink = async (data, type) => {
    try {
      if (!data?.nameStatus && type !== "disconnect") {
        return await _sendErrorToast(
          "Display name status not found. Please check your Meta account.",
        );
      }

      if (
        (!data?.phoneStatus || data?.phoneStatus !== "CONNECTED") &&
        type !== "disconnect"
      ) {
        return await _sendErrorToast(
          "Your phone number is not connected. Please connect it in Meta account.",
        );
      }

      if (data?.nameStatus === "DECLINED" && type !== "disconnect") {
        return await _sendErrorToast(
          "Your display name request was rejected. Please resubmit for approval.",
        );
      }

      if (
        (data?.nameStatus === "AVAILABLE_WITHOUT_REVIEW" ||
          data?.nameStatus === "NON_EXISTS") &&
        type !== "disconnect"
      ) {
        return await _sendErrorToast(
          "Your display name has not been reviewed yet. Please wait for Meta approval.",
        );
      }

      if (!liveBotId || liveBotId === undefined || liveBotId === "undefined")
        return await _sendErrorToast("Bot is not live yet!");
      setConnection(true);

      setConnectionStatus((prev) => ({ ...prev, [data._id]: true }));
      let isChanged = false;

      if (type === "connect") {
        console.log(phoneNumbers);
        const shouldUpdateState = phoneNumbers?.some(
          (item) =>
            item._id === data._id &&
            data.botCustomId &&
            data.botCustomId !== botCustomId,
        );

        if (shouldUpdateState) {
          isChanged = true;
          setIsExist((prev) => ({
            ...prev,
            [data._id]: true,
          }));
        }
      }

      if (isChanged) return;

      const res = await axiosPut(
        `/configurations/${type === "disconnect" ? "disconnectAcccount" : "connectAcccount"}`,
        {
          siteName: "whatsapp",
          _id: data._id,
          botId: liveBotId,
          botCustomId,
        },
      );

      if (res.data?.message === "Data is updated successfully") {
        fReload();
        const actionText = type === "replace" ? "replaced" : type;
        await _sendSuccessToast(
          `Your Whatsapp number ${actionText}d successfully`,
        );
        queryClient.invalidateQueries({
          queryKey: ["configurations", "whatsapp"],
        });
      } else {
        dispatch(
          userSlice.actions.setToastPopUp({
            show: true,
            toastType: "error",
            message: res.data?.message,
          }),
        );
      }
      if (type === "replace") {
        setIsExist((prev) => ({
          ...prev,
          [data._id]: false,
        }));
      }
      onClose();
    } catch (err) {
      console.log(err);
      await _sendErrorToast(
        "Failed to process the request. Please check your connection or try again.",
      );
      if (type === "replace") {
        setIsExist((prev) => ({
          ...prev,
          [data._id]: false,
        }));
      }
      onClose();
    } finally {
      setConnection(false);
      setConnectionStatus((prev) => ({ ...prev, [data._id]: false }));
    }
  };

  async function _sendErrorToast(err?: any) {
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "error",
        message: !!err
          ? typeof err === "string"
            ? err
            : typeof err?.response?.data?.message === "string"
              ? err?.response?.data?.message
              : "Something went wrong"
          : "Something went wrong",
      }),
    );
  }

  async function _sendSuccessToast(msg?: any) {
    dispatch(
      userSlice.actions.setToastPopUp({
        show: true,
        toastType: "success",
        message: msg,
      }),
    );
  }
  if (!state) return null;

  return (
    <>
      {!whatsappConfiguration?.data?.isConnected && (
        <div className="mt-[10px]">
          <h4 className="mb-[10px] text-[16px] font-medium text-text-clr max-[1280px]:!text-[14px]">
            Connected Account
          </h4>

          {/* shows all phone numbers connected to the account */}
          <div className="fb-pages skeletonPages rounded-[20px] bg-[#fafafa] p-[20px]">
            <div className="mb-[20px] flex flex-col gap-[10px]">
              <h3 className="text-[14px] !font-normal leading-[110%] !text-[#666] max-[1280px]:!text-[13px]">
                Account Name
              </h3>
              <div className="w-100 flex items-center justify-between gap-[10px] rounded-[10px] border border-[rgba(0,0,0,0.10)] bg-[#fff] p-[15px]">
                <div className="user-details-fb">
                  <img
                    src={whatsappConfiguration?.data?.picture}
                    alt=""
                    className="!h-[20px] !w-[20px]"
                  />
                  <p className="!text-[16px] leading-[100%]">
                    {whatsappConfiguration?.data?.name}
                  </p>
                </div>
                <button
                  className="flex-cnt h-[24px] w-[24px] rounded-[6px] !bg-[#FFEDEE] transition-shadow duration-300 hover:[box-shadow:0_4px_12px_rgba(251,95,102,0.4)]"
                  onClick={() => setWhatsappDisconnecting(true)}
                >
                  <svg
                    width={14}
                    height={14}
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_5565_25906)">
                      <path
                        d="M6.97759 12.6073H1.93188C1.62241 12.6073 1.37126 12.3562 1.37126 12.0467V1.95535C1.37126 1.64588 1.62244 1.39473 1.93188 1.39473H6.97759C7.28761 1.39473 7.53821 1.14413 7.53821 0.834109C7.53821 0.524084 7.28761 0.273438 6.97759 0.273438H1.93188C1.0046 0.273438 0.25 1.02807 0.25 1.95535V12.0467C0.25 12.974 1.0046 13.7286 1.93188 13.7286H6.97759C7.28761 13.7286 7.53821 13.478 7.53821 13.168C7.53821 12.8579 7.28761 12.6073 6.97759 12.6073Z"
                        fill="#FB5F66"
                      />
                      <path
                        d="M13.5832 6.60332L10.1746 3.23953C9.95482 3.022 9.59939 3.02482 9.38186 3.24514C9.16433 3.46547 9.16657 3.82034 9.38747 4.03787L11.8234 6.44185H5.29597C4.98595 6.44185 4.73535 6.69244 4.73535 7.00247C4.73535 7.31249 4.98595 7.56311 5.29597 7.56311H11.8234L9.38747 9.96709C9.16659 10.1846 9.16491 10.5395 9.38186 10.7598C9.434 10.8127 9.49614 10.8547 9.56467 10.8834C9.6332 10.9121 9.70674 10.9269 9.78103 10.9269C9.92344 10.9269 10.0658 10.8731 10.1746 10.7654L13.5832 7.40161C13.6361 7.34943 13.6781 7.28728 13.7067 7.21876C13.7354 7.15024 13.7502 7.07672 13.7503 7.00244C13.7503 6.85225 13.6903 6.70929 13.5832 6.60332Z"
                        fill="#FB5F66"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_5565_25906">
                        <rect
                          width={13.5}
                          height={13.5}
                          fill="white"
                          transform="translate(0.25 0.25)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
            </div>
            <h3 className="text-[14px] !font-normal leading-[110%] !text-[#666] max-[1280px]:!text-[13px]">
              Details
            </h3>
            {phoneNumbers?.length > 0 && (
              <div className="fb-list whatsapp_table whatsapp_detail_table overflow-x-auto">
                <table className="mt-[10px] min-w-full overflow-hidden rounded-[10px] border border-[rgba(167,80,80,0.1)]">
                  <thead className="flex w-full rounded-t-[10px] border border-[rgba(0,0,0,0.10)] bg-gray-100 text-gray-700">
                    <tr
                      className="grid"
                      style={{
                        gridTemplateColumns:
                          "220px 250px 150px minmax(210px, 1fr)",
                      }}
                    >
                      {phoneNumbers.some((p) => p.name) && (
                        <th className="px-[20px] py-[13px]">Name</th>
                      )}

                      <th className="px-[20px] py-[13px]">Phone Number</th>
                      <th className="px-[20px] py-[13px]">Status</th>
                      <th className="px-[20px] py-[13px]">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {phoneNumbers.map((data, index) => (
                      <Fragment key={index}>
                        <tr
                          className={`grid ${
                            data?.showPrompt ? "block" : "table-row"
                          } border-b`}
                          style={{
                            gridTemplateColumns:
                              "220px 250px 150px minmax(210px, 1fr)",
                          }}
                        >
                          {/* {data?.name && ( */}
                          <td className="flex items-center gap-[8px] px-[20px] py-[13px]">
                            {data?.name ?? "N/A "}
                            {data?.nameStatus === "DECLINED" ? (
                              <span className="rounded-[5px] bg-[#3395dd] px-[6px] py-[4px] text-[12px] leading-[100%] text-white">
                                Rejected
                              </span>
                            ) : data?.nameStatus ===
                              "AVAILABLE_WITHOUT_REVIEW" ? (
                              <span className="rounded-[5px] bg-[#f39c12] px-[6px] py-[4px] text-[12px] leading-[100%] text-white">
                                Not Verified
                              </span>
                            ) : data?.nameStatus === "NON_EXISTS" ? (
                              <span className="rounded-[5px] bg-[#f39c12] px-[6px] py-[4px] text-[12px] leading-[100%] text-white">
                                Not Verified
                              </span>
                            ) : (
                              <span className="rounded-[5px] bg-[#3395dd] px-[6px] py-[4px] text-[12px] leading-[100%] text-white">
                                Verified
                              </span>
                            )}
                          </td>
                          {/* )} */}
                          <td className="flex items-center gap-[8px] px-[20px] py-[13px]">
                            {data?.display_phone_number}
                            {data?.connected &&
                              data?.botCustomId === botCustomId && (
                                <span className="rounded-[5px] bg-[#3395dd] px-[6px] py-[4px] text-[12px] leading-[100%] text-white">
                                  Connected
                                </span>
                              )}
                          </td>

                          <td className="break-all px-[20px] py-[13px]">
                            <span
                              className={`flex items-center gap-[6px] rounded-full px-[8px] py-[4px] text-[14px] !capitalize leading-normal ${data.phoneStatus !== "CONNECTED" ? "bg-[#FFE7E6]" : "bg-[#D5F6DC]"}`}
                            >
                              <span>
                                {data.phoneStatus === "CONNECTED" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={17}
                                    height={16}
                                    viewBox="0 0 17 16"
                                    fill="none"
                                  >
                                    <g clipPath="url(#clip0_5565_21916)">
                                      <path
                                        d="M8.66699 0C4.25449 0 0.666992 3.5875 0.666992 8C0.666992 12.4125 4.25449 16 8.66699 16C13.0795 16 16.667 12.4125 16.667 8C16.667 3.5875 13.0795 0 8.66699 0ZM8.66699 15C4.80762 15 1.66699 11.8594 1.66699 8C1.66699 4.14062 4.80762 1 8.66699 1C12.5264 1 15.667 4.14062 15.667 8C15.667 11.8594 12.5264 15 8.66699 15ZM12.5357 5.30312C12.7295 5.49687 12.7295 5.81563 12.5357 6.00938L7.84824 10.6969C7.75137 10.7937 7.62324 10.8438 7.49512 10.8438C7.36699 10.8438 7.23887 10.7937 7.14199 10.6969L4.79824 8.35312C4.60449 8.15937 4.60449 7.84062 4.79824 7.64687C4.99199 7.45312 5.31074 7.45312 5.50449 7.64687L7.49512 9.6375L11.8295 5.30312C12.0232 5.10625 12.342 5.10625 12.5357 5.30312Z"
                                        fill="#28B446"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_5565_21916">
                                        <rect
                                          width={16}
                                          height={16}
                                          fill="white"
                                          transform="translate(0.666992)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                ) : data.phoneStatus === "EXPIRED" ? (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={17}
                                    height={16}
                                    viewBox="0 0 17 16"
                                    fill="none"
                                  >
                                    <g clipPath="url(#clip0_5565_19980)">
                                      <path
                                        d="M11.334 5.33191C11.2089 5.20693 11.0394 5.13672 10.8626 5.13672C10.6858 5.13672 10.5163 5.20693 10.3913 5.33191L8.66728 7.05591L6.94328 5.33191C6.81755 5.21047 6.64915 5.14327 6.47435 5.14479C6.29955 5.14631 6.13234 5.21643 6.00874 5.34003C5.88513 5.46364 5.81502 5.63084 5.8135 5.80564C5.81198 5.98044 5.87918 6.14884 6.00062 6.27458L7.72462 7.99858L6.00062 9.72258C5.87918 9.84831 5.81198 10.0167 5.8135 10.1915C5.81502 10.3663 5.88513 10.5335 6.00874 10.6571C6.13234 10.7807 6.29955 10.8508 6.47435 10.8524C6.64915 10.8539 6.81755 10.7867 6.94328 10.6652L8.66728 8.94124L10.3913 10.6652C10.517 10.7867 10.6854 10.8539 10.8602 10.8524C11.035 10.8508 11.2022 10.7807 11.3258 10.6571C11.4494 10.5335 11.5195 10.3663 11.5211 10.1915C11.5226 10.0167 11.4554 9.84831 11.334 9.72258L9.60995 7.99858L11.334 6.27458C11.4589 6.14956 11.5291 5.98002 11.5291 5.80324C11.5291 5.62647 11.4589 5.45693 11.334 5.33191Z"
                                        fill="#FB3024"
                                      />
                                      <path
                                        d="M8.667 0C7.08475 0 5.53803 0.469192 4.22243 1.34824C2.90684 2.22729 1.88146 3.47672 1.27596 4.93853C0.670458 6.40034 0.512032 8.00887 0.820714 9.56072C1.1294 11.1126 1.89132 12.538 3.01014 13.6569C4.12896 14.7757 5.55443 15.5376 7.10627 15.8463C8.65812 16.155 10.2667 15.9965 11.7285 15.391C13.1903 14.7855 14.4397 13.7602 15.3188 12.4446C16.1978 11.129 16.667 9.58225 16.667 8C16.6647 5.87897 15.8211 3.84547 14.3213 2.34568C12.8215 0.845886 10.788 0.00229405 8.667 0ZM8.667 14.6667C7.34845 14.6667 6.05952 14.2757 4.96319 13.5431C3.86687 12.8106 3.01238 11.7694 2.5078 10.5512C2.00321 9.33305 1.87119 7.99261 2.12843 6.6994C2.38566 5.40619 3.0206 4.21831 3.95295 3.28596C4.8853 2.35361 6.07319 1.71867 7.36639 1.46143C8.6596 1.2042 10 1.33622 11.2182 1.8408C12.4364 2.34539 13.4776 3.19987 14.2101 4.2962C14.9427 5.39253 15.3337 6.68146 15.3337 8C15.3317 9.76752 14.6287 11.4621 13.3789 12.7119C12.1291 13.9617 10.4345 14.6647 8.667 14.6667Z"
                                        fill="#FB3024"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_5565_19980">
                                        <rect
                                          width={16}
                                          height={16}
                                          fill="white"
                                          transform="translate(0.666992)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={17}
                                    height={16}
                                    viewBox="0 0 17 16"
                                    fill="none"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M8.08319 3.11226C8.14074 3.00774 8.22528 2.92057 8.32801 2.85987C8.43073 2.79916 8.54787 2.76713 8.66719 2.76713C8.78651 2.76713 8.90364 2.79916 9.00636 2.85987C9.10909 2.92057 9.19364 3.00774 9.25119 3.11226L14.3299 12.3456C14.3857 12.4471 14.4141 12.5615 14.4123 12.6774C14.4105 12.7933 14.3785 12.9067 14.3195 13.0064C14.2604 13.1062 14.1764 13.1888 14.0757 13.2462C13.975 13.3036 13.8611 13.3337 13.7452 13.3336H3.58919C3.47328 13.3337 3.35936 13.3036 3.25865 13.2462C3.15794 13.1888 3.07393 13.1062 3.0149 13.0064C2.95587 12.9067 2.92387 12.7933 2.92205 12.6774C2.92023 12.5615 2.94865 12.4471 3.00452 12.3456L8.08319 3.11226ZM10.4199 2.46959C9.65985 1.08826 7.67452 1.08826 6.91452 2.46959L1.83652 11.7029C1.10319 13.0363 2.06719 14.6669 3.58919 14.6669H13.7452C15.2665 14.6669 16.2312 13.0363 15.4985 11.7029L10.4199 2.46959ZM8.66719 5.33359C8.844 5.33359 9.01357 5.40383 9.13859 5.52886C9.26362 5.65388 9.33385 5.82345 9.33385 6.00026V8.66693C9.33385 8.84374 9.26362 9.01331 9.13859 9.13833C9.01357 9.26336 8.844 9.33359 8.66719 9.33359C8.49038 9.33359 8.32081 9.26336 8.19578 9.13833C8.07076 9.01331 8.00052 8.84374 8.00052 8.66693V6.00026C8.00052 5.82345 8.07076 5.65388 8.19578 5.52886C8.32081 5.40383 8.49038 5.33359 8.66719 5.33359ZM9.33385 11.3336C9.33385 11.5104 9.26362 11.68 9.13859 11.805C9.01357 11.93 8.844 12.0003 8.66719 12.0003C8.49038 12.0003 8.32081 11.93 8.19578 11.805C8.07076 11.68 8.00052 11.5104 8.00052 11.3336C8.00052 11.1568 8.07076 10.9872 8.19578 10.8622C8.32081 10.7372 8.49038 10.6669 8.66719 10.6669C8.844 10.6669 9.01357 10.7372 9.13859 10.8622C9.26362 10.9872 9.33385 11.1568 9.33385 11.3336Z"
                                      fill="#FB3024"
                                    />
                                  </svg>
                                )}
                              </span>

                              {data?.phoneStatus
                                ? data.phoneStatus.toLowerCase() === "connected"
                                  ? "Active"
                                  : data.phoneStatus.toLowerCase() === "pending"
                                    ? "Pending"
                                    : data.phoneStatus
                                        .replace(/_/g, " ")
                                        .toLowerCase()
                                : "Pending"}
                            </span>
                          </td>
                          <td className="px-[20px] py-[13px]">
                            {data?.connected &&
                            data?.botCustomId === botCustomId ? (
                              <button
                                disabled={!!connectionStatus[data._id]}
                                className="social_disconnect flex h-[30px] items-center gap-[8px] rounded-[10px] border border-solid border-[rgba(251,95,102,0.1)] bg-[#FEE6E7] px-[15px] py-[10px] text-[14px] leading-[110%] text-primary-clr"
                                onClick={() => handleLink(data, "disconnect")}
                              >
                                <DisconnectIcon />{" "}
                                {connectionStatus[data._id]
                                  ? "Disconnecting..."
                                  : "Disconnect"}
                              </button>
                            ) : (
                              <button
                                disabled={!!connectionStatus[data._id]}
                                className="border-[rgba(0, 0, 0, 0.10)] social_connect flex h-[30px] items-center gap-[8px] rounded-[10px] border border-solid bg-[#F9F9F9] px-[15px] py-[10px] text-[14px] leading-[110%] text-[#666]"
                                onClick={() => handleLink(data, "connect")}
                              >
                                <ConnectIcon />{" "}
                                {connectionStatus[data._id]
                                  ? "Connecting..."
                                  : "Connect"}
                              </button>
                            )}
                          </td>
                        </tr>

                        {data?.connected && isExist[data._id] && (
                          <ModalWrapper>
                            {/* <AnimatePresence> */}
                            <div className="createbot-modal">
                              <motion.div
                                initial={{ scale: 0.9, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0.9, opacity: 0 }}
                              >
                                <div className="flex-cnt mx-4 w-[680px] flex-col rounded-[10px] bg-[linear-gradient(180deg,_#FB5F66_-51.8%,_#FFFFFF_70.59%)] p-[40px]">
                                  <ErrSvgIcon />
                                  <h2 className="mb-[10px] mt-[20px] text-[18px] font-medium text-text-clr">
                                    Replace Bot
                                  </h2>
                                  <p className="mb-[30px] text-center text-[14px] text-[#444444CC]">
                                    This account is already connected to another
                                    bot. <br />
                                    Do you want to replace the earlier bot with
                                    current bot?
                                  </p>

                                  <div className="flex justify-end gap-4">
                                    <motion.button
                                      whileHover={{
                                        scale: 1.1,
                                        transition: { duration: 0.5 },
                                      }}
                                      whileTap={{ scale: 0.9 }}
                                      onClick={() =>
                                        setIsExist((prev) => ({
                                          ...prev,
                                          [data._id]: false,
                                        }))
                                      }
                                      className="h-[45px] w-[170px] rounded-[6px] border border-primary-clr text-[14px] text-primary-clr"
                                    >
                                      Cancel
                                    </motion.button>
                                    <motion.button
                                      whileHover={{
                                        scale: 1.1,
                                        transition: { duration: 0.5 },
                                      }}
                                      whileTap={{ scale: 0.9 }}
                                      onClick={() =>
                                        handleLink(data, "replace")
                                      }
                                      className="w-[170px] rounded-[6px] border border-primary-clr bg-primary-clr text-[14px] text-white"
                                    >
                                      Replace Bot
                                    </motion.button>
                                  </div>
                                </div>
                              </motion.div>
                            </div>
                            {/* </AnimatePresence> */}
                          </ModalWrapper>
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {whatsappDisconnecting ? (
        <ModalWrapper>
          <BooleanModal
            onConfirm={() => disconnectMeta()}
            onCancel={() => setWhatsappDisconnecting(false)}
            content={{
              title: "Logout of WhatsApp",
              message: `Logging out will stop all active workflows running on WhatsApp. \n Are you sure you want to continue?`,
            }}
            buttons={{
              confirm: "Logout",
              cancel: "Cancel",
            }}
          />
        </ModalWrapper>
      ) : null}
    </>
  );
}
